export default "__VITE_ASSET__DFTsJ4rN__"